import { getObjectKeys } from ".";

export const getObjectLength = (obj: Object): number => {
  const keys = getObjectKeys(obj);

  return keys?.length || 0;
};
